import { RecoilRoot } from "recoil"
import R1 from "./R1"

export default function RMain() {
  return (
    <div>
      <RecoilRoot>
        <R1 />
      </RecoilRoot>
    </div>
  )
}
